export default __webpack_public_path__ + "static/media/氨氮分析仪.696695af.png";